import { render, staticRenderFns } from "./Riesgo.vue?vue&type=template&id=e70a9542&scoped=true"
import script from "./Riesgo.vue?vue&type=script&setup=true&lang=js"
export * from "./Riesgo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Riesgo.vue?vue&type=style&index=0&id=e70a9542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a9542",
  null
  
)

export default component.exports